export type LocationMeta = {
  id?: number;
  paramName: string;
  paramValue: string;
  branchId?: number;
};
